export default __webpack_public_path__ + "static/media/undraw_thoughts_e49y.39d0bbce.svg";